import { render } from "./App.vue?vue&type=template&id=6f8f9987"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6f8f9987&lang=less"

import exportComponent from "/home/runner/work/i/i/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__